module.exports = "/img/_/_/_/assets/images/avatar/full_right/male//rogue.jpg?90b8f3cedcbcc4d2cc8d4b28d10335a2";